import React, { Fragment } from "react";
import Header from "./header/Header";
import Body from "./body/Body";

const AnsweringAIDiagnosis = ( props ) => {

  const {
    Logger,
    children,
    ...PROPS
  } = props;

  return (
    <Logger>
      <div className="layout-def layout-learning gm">
        <Header { ...PROPS } />
        <Body { ...PROPS } />
      </div>
    </Logger>
  );

};

AnsweringAIDiagnosis.defaultProps = {
  Logger : Fragment
};

export default AnsweringAIDiagnosis;
